import React, { useMemo, useState } from 'react'
import { observer } from 'mobx-react'
import { doProductMobx } from 'restaurant'
import { SingleChoose, SingleChooseItem } from '@cps'
import { classNames } from '@dt/fe-utils'
import './index.scss'
import { filter } from '@dt/fe-utils/dist/lodash'

interface IProps {
  singleNo: string;
  disableScale?: boolean;
  hidePrice?: boolean;
  onClick: (groupsNo: string) => void;
}

const AboardScale: React.FC<IProps> = ({ disableScale, hidePrice, onClick }) => {
  const LineShow = doProductMobx.doProduct.scales.length > 9

  const [splitLineShow, setSplitLineShow] = useState(LineShow)

  const showScales = useMemo(() => {
    return doProductMobx.doProduct.scales?.length > 1 || doProductMobx.doProduct.scales?.[0]?.name || doProductMobx.doProduct.isOpenPrice
  }, [doProductMobx.doProduct.scales])

  if (!doProductMobx.doProduct.scales?.length) {
    return null
  }

  const handleSelectScale = (item) => {
    if (item.saleCnt === 0 || disableScale || item.disable) {
      return
    }
    doProductMobx.selectScale(item.no)
    onClick('')
  }

  const handleClick = () => {
    setSplitLineShow(false)
  }

  const scales = doProductMobx.doProduct.isScaleOpenPrice ? filter(doProductMobx.doProduct.scales, (scales) => !scales.isOpenPrice) : doProductMobx.doProduct.scales

  return (
    <div
      className={classNames('choose-scale-list', {
        'has-modify': doProductMobx.doProduct.modifierGroups?.length,
        'disable-scale': disableScale,
        'hide-scale': disableScale || !showScales,
        'hide-price': disableScale || hidePrice
      })}
    >
      <SingleChoose
        isShow={!splitLineShow}
        name={doProductMobx.doProduct.scaleGroupName}
        onClick={() => onClick('-1')}
      >
        {scales.map((item) => {
          return (
            <SingleChooseItem
              key={item.no}
              data={{
                no: item.no,
                name: item.name,
                price: item.actualPrice,
                notSale: item.saleCnt === 0,
                pic: item.picArr?.length ? (item.no === doProductMobx.doProduct.scaleNo ? item.picArr[1] : item.picArr[0]) : null,
                icon: !item.picArr?.length && item.pic ? (`${item.pic}${item.no === doProductMobx.doProduct.scaleNo ? 'xuanzhong' : ''}2x`) : null,
                disable: item.disable
              }}
              className={`${
                item.no === doProductMobx.doProduct.scaleNo ? 'selected ' : ''
              }`}
              onClick={() => handleSelectScale(item)}
            />
          )
        })}
      </SingleChoose>
      {
        splitLineShow ? (
          <div className='to-choose-tip' data-cypid='chooseScaleShow' onClick={handleClick}>
            <div className='selected-list'>
              <i className='iconfont icon-a-shenglvehao1'></i>
            </div>
            <i className='iconfont icon-chevron-right'></i>
          </div>
        ) : ''
      }

    </div>
  )
}

export default observer(AboardScale)
